<div *ngFor="let d of vm.data.driverPayrollCompareData">
    <mdb-card narrower="true" cascade="true">
        <app-card-header title="Payroll Comparison" [headingSize]="3"
            [fullHeader]="true"></app-card-header>
        <mdb-card-body cascade="true">
            <div class="row">
                <div class="col-md-1 mt-n4"></div>
                <div class="col-md-5 mt-n4">
                    <mdb-card narrower="true" cascade="true" *ngIf="d.currentPeriod">
                        <mdb-card-body cascade="true">
                            <div class="text-center">
                                <span style="font-weight: bold; text-decoration: underline;">Current</span>
                                <!-- <span style="font-weight: bold; text-decoration: underline;">This Year</span> -->
                            </div>
                            <!-- <div class="text-center">
                                <span>Number of Compare Month:</span>
                                <span style="font-weight: bold;">&nbsp;{{d.currentPeriod.compareMonth}}</span>
                            </div> -->
                            <!-- <div class="text-center">
                                <span>Periods Statements / Checks:</span>
                                <span
                                    style="font-weight: bold;">&nbsp;{{d.currentPeriod.statementPeriods}}
                                    / {{d.currentPeriod.checkPeriods}}</span>
                                &nbsp;&nbsp;
                                <mdb-icon *ngIf="d.stat.statementPeriodsStat == -1 || d.stat.checkPeriodsStat == -1" style="color:red;" fas icon="arrow-down"
                                    class="prefix" size="md"></mdb-icon>
                                <mdb-icon *ngIf="d.stat.statementPeriodsStat == 1 && d.stat.checkPeriodsStat == 1" style="color: green" fas icon="arrow-up"
                                    class="prefix" size="md"></mdb-icon>
                            </div> -->
                            <div class="text-center">
                                <span>Days Worked / Time Off:</span>
                                <span style="font-weight: bold;">&nbsp;{{d.currentPeriod.workedDays}}
                                    / {{d.currentPeriod.ptoDays}}</span>
                                &nbsp;&nbsp;
                                <mdb-icon *ngIf="d.stat.daysPtosCountStat == -1" style="color:red;" fas
                                    icon="arrow-down" class="prefix" size="md"></mdb-icon>
                                <mdb-icon *ngIf="d.stat.daysPtosCountStat == 1" style="color: green" fas icon="arrow-up"
                                    class="prefix" size="md"></mdb-icon>
                            </div>
                            <div class="text-center">
                                <span>Trips / StandBys:</span>
                                <span style="font-weight: bold;">&nbsp;{{d.currentPeriod.tripCount}}
                                    / {{d.currentPeriod.standByCount}}</span>
                                &nbsp;&nbsp;
                                <mdb-icon *ngIf="d.stat.tripsStandBysCountStat == -1" style="color:red;" fas
                                    icon="arrow-down" class="prefix" size="md"></mdb-icon>
                                <mdb-icon *ngIf="d.stat.tripsStandBysCountStat == 1" style="color: green" fas
                                    icon="arrow-up" class="prefix" size="md"></mdb-icon>
                            </div>
                            <!-- <div class="text-center">
                                <span>Discretionary Gratuity:</span>
                                <span style="font-weight: bold;">&nbsp;{{d.currentPeriod.totalGratuity |
                                    currency}}</span>
                                &nbsp;&nbsp;
                                <mdb-icon *ngIf="d.stat.totalGratuityStat == -1" style="color:red;" fas
                                    icon="arrow-down" class="prefix" size="md"></mdb-icon>
                                <mdb-icon *ngIf="d.stat.totalGratuityStat == 1" style="color: green" fas icon="arrow-up"
                                    class="prefix" size="md"></mdb-icon>
                            </div> -->
                            <div class="text-center">
                                <span>Compensation:</span>
                                <span style="font-weight: bold;">&nbsp;{{d.currentPeriod.grossCheckPayment |
                                    currency}}</span>
                                &nbsp;&nbsp;
                                <mdb-icon *ngIf="d.stat.grossCheckPaymentStat == -1" style="color:red;" fas
                                    icon="arrow-down" class="prefix" size="md"></mdb-icon>
                                <mdb-icon *ngIf="d.stat.grossCheckPaymentStat == 1" style="color: green" fas
                                    icon="arrow-up" class="prefix" size="md"></mdb-icon>
                            </div>
                            <div class="text-center">
                                <span>Statements Periods From / To:</span>
                                <span style="font-weight: bold;">&nbsp;{{d.currentPeriod.fromDate}}
                                    / {{d.currentPeriod.toDate}}</span>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
                <div class="col-md-5 mt-n4">
                    <mdb-card narrower="true" cascade="true" *ngIf="d.lastPeriod">
                        <mdb-card-body cascade="true">
                            <div class="text-center">
                                <span style="font-weight: bold; text-decoration: underline;">Last</span>
                                <!-- <span style="font-weight: bold; text-decoration: underline;">Last Year</span> -->
                            </div>
                            <!-- <div class="text-center">
                                <span>Number of Compare Month:</span>
                                <span style="font-weight: bold;">&nbsp;
                                    <ng-container *ngIf="d.currentPeriod.compareMonth > 0">{{d.currentPeriod.compareMonth}}</ng-container>
                                    <ng-container *ngIf="d.currentPeriod.compareMonth == 0">N/A</ng-container>
                                </span>
                            </div> -->
                            <!-- <div class="text-center">
                                <span>Periods Statements / Checks:</span>
                                <span
                                    style="font-weight: bold;">&nbsp;{{d.lastPeriod.statementPeriods}}
                                    / {{d.lastPeriod.checkPeriods}}</span>
                            </div> -->
                            <div class="text-center">
                                <span>Days Worked / Time Off:</span>
                                <span style="font-weight: bold;">&nbsp;
                                    <ng-container *ngIf="d.lastPeriod.workedDays + d.lastPeriod.ptoDays > 0">{{d.lastPeriod.workedDays}} / {{d.lastPeriod.ptoDays}}</ng-container>
                                    <ng-container *ngIf="d.lastPeriod.workedDays + d.lastPeriod.ptoDays == 0">N/A</ng-container>
                                </span>
                            </div>
                            <div class="text-center">
                                <span>Trips / StandBys:</span>
                                <span style="font-weight: bold;">&nbsp;
                                    <ng-container *ngIf="d.lastPeriod.tripCount + d.lastPeriod.standByCount > 0">{{d.lastPeriod.tripCount}} / {{d.lastPeriod.standByCount}}</ng-container>
                                    <ng-container *ngIf="d.lastPeriod.workedDays + d.lastPeriod.standByCount == 0">N/A</ng-container>
                                </span>
                            </div>
                            <!-- <div class="text-center">
                                <span>Discretionary Gratuity:</span>
                                <span style="font-weight: bold;">&nbsp;
                                    <ng-container *ngIf="d.lastPeriod.totalGratuity > 0">{{d.lastPeriod.totalGratuity | currency}}</ng-container>
                                    <ng-container *ngIf="d.lastPeriod.totalGratuity == 0">N/A</ng-container>
                                </span>
                            </div> -->
                            <div class="text-center">
                                <span>Compensation:</span>
                                <span style="font-weight: bold;">&nbsp;
                                    <ng-container *ngIf="d.lastPeriod.grossCheckPayment > 0">{{d.lastPeriod.grossCheckPayment | currency}}</ng-container>
                                    <ng-container *ngIf="d.lastPeriod.grossCheckPayment == 0">N/A</ng-container>
                                </span>
                            </div>
                            <div class="text-center">
                                <span>Statements Periods From / To:</span>
                                <span style="font-weight: bold;">&nbsp;
                                    <ng-container *ngIf="d.lastPeriod.fromDate.length + d.lastPeriod.toDate.length > 0">{{d.lastPeriod.fromDate}} / {{d.lastPeriod.toDate}}</ng-container>
                                    <ng-container *ngIf="d.lastPeriod.fromDate.length + d.lastPeriod.toDate.length == 0">N/A</ng-container>
                                </span>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>
</div>